import React from "react";

/**
 * A mobile-optimized field display component with label and value.
 * Shows edit component when in edit mode.
 */
export default function MobileField({ label, value, edit, component }) {
  if (!edit && !value && !component) return null;
  
  return (
    <div className="mobile-field">
      <div className="mobile-field__label">{label}</div>
      <div className="mobile-field__value">
        {edit && component ? component : value}
      </div>
    </div>
  );
}

